<template>
    <div>
      <el-dialog :title="dialTitle" :visible.sync="dialogVisible" >
      <v-form-render :form-json="dialFormJson" :form-data="dialFormData" :option-data="dialOptionData" ref="vFormRefdilog">
      </v-form-render>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="sel_data">提交 </el-button>
      </div>
      </el-dialog>
      <v-form-render   :form-json="formJson" :form-data="formData" :option-data="optionData" ref="vFormRef">
      </v-form-render>
      <!-- <el-button type="primary" @click="submitForm">Submit</el-button> -->
    </div>
  </template>
  <script>
    import * as forms from '@/api/forms'
    import  * as getMaoToken  from '@/utils/auth'
    export default {
      data() {
        return {
          fieldListApi: {
          URL: process.env.VUE_APP_BASE_API +'/Common/GetFieldList',
          labelKey: 'fieldLabel',
          nameKey: 'fieldName',
          headers: {
            'X-Token':getMaoToken.getToken()
            }
          },
          renderObject1:{},//弹出框渲染器
          renderObjet2:{},//弹出框渲染器2
          formJson:{},
          formData: {},
          optionData: {},
          dialogVisible: false,//弹窗显示
          dialFormJson:{},//弹窗渲染数据
          dialFormData:{},//弹窗表单数据
          dialOptionData:{},//弹窗选择数据
          dialTitle:"弹出框"
        }
      },
      methods: {
        submitForm() {          
          this.$refs['vFormRef'].vFormRef.getFormData().then(formData => {
            // Form Validation OK
               alert( JSON.stringify(formData) )
          }).catch(error => {
            // Form Validation failed
            this.$message.error(error)
          })
        },
        fetchData(id) {
         return forms
            .get({"id":id})
            
        },
        fetchFieldData(relateId){
            return forms.getFieldList({

              relateId:relateId
            })

        }
        ,openDialog(formid){
          console.log("单据唯一ID" + formid)
          
          var objPage1 = this;

          if(!formid)
          {
              console.log(formid)
          }

          this.fetchData("425732924264517").then(res => {
            if (res.code == 200) {
                   

                 this.dialFormJson = res.result.contentData
                console.log(this.dialFormJson)

                this.renderObjet2.setFormJson(res.result.contentData)
             // this.$refs.vFormRefdilog.setFormJson(res.result.contentData)
             this.$refs.vFormRefdilog.$nextTick(() => {
                this.renderObject1 = this.$refs.vFormRefdilog;
                this.$refs.vFormRefdilog.addEC('myEC', objPage1)
              })
            }
          })
            this.dialogVisible = true
        },
        handleClose() {
            this.$confirm('确认关闭？')
              .then(() => {
               // done();
              })
              .catch(() => {});
         },
         ///
         sel_data:function(thisWight,oldJson,formId){
             console.log(thisWight)
             console.log(oldJson)
             console.log(formId)

         },
         cancel:function()
         {
          this.$confirm('确认关闭？')
              .then(() => {
                this.dialogVisible = false
               // done();
              })
              .catch(() => {});
         }

      },
      mounted(){
        console.log(this.$refs.length)
        console.log("获取渲染--")
        console.log(this)
        console.log("获取渲染应用--")
        console.log(this.$refs.vFormRef)
         var objPage =this;     
         this.fetchData("8e1b6cb6-5a2b-4292-9851-a60edd10b804").then(res => {
            if (res.code == 200) {

              console.log(res.result.contentData)
              this.$refs.vFormRef.setFormJson(res.result.contentData)
              this.$refs.vFormRef.$nextTick(() => {

                console.log("注入外部组件")
                this.$refs.vFormRef.addEC('myEC', objPage)
                console.log("注入外部组件结束11")
              //  this.renderObjet2 = this.$refs.vFormRef
                //this.$refs.vFormRef.setFormData(res.result.contentData)
              })
            }
          })

          this.renderObjet2 = this.$refs.vFormRefdilog;

      }
 
    }
  </script>